import React from 'react';
import PropTypes from 'prop-types';

import useAppContext from '../../context/useAppContext';

import ProductModel from '../../models/productModel';

import { Route, Switch } from 'react-router-dom';
import Template from '../../components/template/template';
import Loading from '../../components/loading';
import PageError from '../../pages/error/pageError';
import { ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import FormProduct from '../../pages/product/detail/settings/formProduct';
import VariantList from '../../pages/product/detail/variants/variantsList';
import ActivationEventList from '../../pages/product/detail/activation/activationEventList';
import ActivationRatesList from '../../pages/product/detail/activation/activationRatesList';
import { ManagerContextProvider } from '../../pages/manager/components/context';

export default function ProductRouter({ match: { path, url }, organization, productId, history }) {
    const [context, setContext] = useAppContext();
    const toast = React.useContext(ToastContext);
    const { t } = useTranslation();

    const [, loading, syncProduct] = ProductModel.useApiModel(
        {
            id: productId,
            organizationId: organization.id,
            onSuccess: product => {
                setContext({ product, reloadProduct: syncProduct });
            },
            onError: e => {
                if (e.code === 404) {
                    toast.error(t('pageNotFound'));
                } else {
                    toast.error(t('ticket.common.toast_error'));
                }

                history.push(`/ticket/O${organization.id}/products`);
            }
        },
        [productId, organization]
    );

    if (loading || !context.product) {
        return <Loading />;
    }

    return (
        <Template organization={organization} product={context.product}>
            <Switch>
                <Route
                    exact
                    path={`${path}/settings`}
                    render={({
                        match: {
                            params: { productId }
                        }
                    }) => <FormProduct organization={organization} productId={productId} />}
                />
                <Route
                    exact
                    path={`${path}/variants`}
                    render={({
                        match: {
                            params: { productId }
                        }
                    }) => <VariantList organization={organization} productId={productId} />}
                />
                <Route
                    exact
                    path={`${path}/activation`}
                    render={({
                        match: {
                            params: { productId }
                        }
                    }) => (
                        <ManagerContextProvider>
                            <ActivationEventList organization={organization} productId={productId} />
                        </ManagerContextProvider>
                    )}
                />
                <Route
                    exact
                    path={`${path}/activation/E:eventId`}
                    render={({
                        match: {
                            params: { productId, eventId }
                        }
                    }) => <ActivationRatesList organization={organization} productId={productId} eventId={eventId} />}
                />
                {/* Error */}
                <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}/products/${productId}`} />} />
            </Switch>
        </Template>
    );
}

ProductRouter.propTypes = {
    match: PropTypes.object,
    organization: PropTypes.object,
    productId: PropTypes.string
};
